import { Component, OnInit } from '@angular/core';
import { ProductCode } from 'src/app/shared/utilities/product-code';
import { MemberCardBase } from './member-card.base';
import { map, Observable } from 'rxjs';
import { config } from '@fgb/core';
@Component({
  selector: 'fgb-member-card',
  templateUrl: './member-card.component.html',
  styleUrls: ['./member-card.component.scss'],
})
export class MemberCardComponent extends MemberCardBase implements OnInit {
  productCode = ProductCode;

  pointsBalance$: Observable<number | undefined>;

  ngOnInit() {
    super.init();

    this.pointsBalance$ = this.balanceQuery
      .selectPurse(config.purseConfig.virtualLoyalty)
      .pipe(map((bal) => Math.ceil(bal ?? 0)));
  }
}
